var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLetterG(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.86 80V68.57H11.43V57.14H0V22.86h11.43V11.43h11.43V0H80v11.43H34.29v11.43H22.86v34.28h11.43v11.43h22.85V45.71H45.71V34.29H80V80z",
    fill: "#e8ffa2"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4MCIgaGVpZ2h0PSI4MCIgdmlld0JveD0iMCAwIDgwIDgwIj4KICA8cGF0aCBkPSJNMjIuODYsODBWNjguNTdIMTEuNDNWNTcuMTRIMFYyMi44NkgxMS40M1YxMS40M0gyMi44NlYwSDgwVjExLjQzSDM0LjI5VjIyLjg2SDIyLjg2VjU3LjE0SDM0LjI5VjY4LjU3SDU3LjE0VjQ1LjcxSDQ1LjcxVjM0LjI5SDgwVjgwWiIgZmlsbD0iI2U4ZmZhMiIvPgo8L3N2Zz4K";
export { SvgLetterG as ReactComponent };